module.exports = __webpack_public_path__ + "img/TOSOLA_thumbnail.d8cdafc4.jpg";